import { INITIAL_STATE } from "ducks/questions";

export function areAllAccepted(answers) {
	return answers.reduce((memo, { isAccepted }) => {
		if (!isAccepted) {
			return false;
		}

		return memo;
	}, true);
}

/*
 * Take an api question response (the one with viewer, target, and question
 * keys) and convert it to the format that this app requires.
 *
 * @param {Object} params - the question response from the api
 * @param {Object} params.question - question info
 * @param {Object} params.target - target response
 * @param {Object} params.viewer - viewer response
 * @return {Object} - the formatted question info
 */
export function formatApiQuestion({ question, target, viewer } = {}) {
	if (!question || !target || !viewer) {
		return INITIAL_STATE.question;
	}

	const wasAnswered = viewer.answer !== null || viewer.skipped;

	const importance = {
		"1": "VERY",
		"3": "SOMEWHAT",
		"4": "LITTLE",
		"5": "IRRELEVANT",
	}[target.importance];

	return {
		question: question.text,
		genre: question.genre,
		id: question.id,
		answers: question.answers.map((text, i) => {
			return {
				text,
				isSelected: viewer.answer === i,
				isAccepted: (target.accepts || []).indexOf(i) >= 0,
			};
		}),
		importance,
		isPrivate: target.answer !== null && !target.public,
		isSkippable: !question.noskip,
		explanation: viewer.note && viewer.note.note ? viewer.note.note : "",
		wasAnswered,
	};
}



// WEBPACK FOOTER //
// ./src/apps/questions/util/helpers.js